import { createFormContext } from "@mantine/form";
import type { BingoGame } from "bingo/types/bingo-game.model";

export const [
  BingoGameFormProvider,
  useBingoGameFormContext,
  useBingoGameForm,
] = createFormContext<Omit<BingoGame, "id">>();
